(function(angular, _) {
    'use strict';
    angular.module('wtApp.wtDropdown').directive('wtDropdown', wtDropdown);
    wtDropdown.$inject = [];
    function wtDropdown() {
        return {
            restrict: 'A',
            scope: {
                defaultElementKey: '=', // The key of the element that is going to be selected by default
                defaultText: '@', // The text to be displayed if no defaultElementKey is given
                elementList: '&', // An array of objects
                elementMapping: '=', // Map of properties to be used...
                clickHandlers: '=',
                layoutOptions: '&',
                debug: '=',
                watchKey: '&'
            },
            templateUrl: function(elem, attrs) {
                return attrs.templateUrl || 'template/dropdown/list.html';
            },
            link: function($scope) {
                // Default behaviour: closed dropdown
                $scope.isOpen = false;
                var keyWatch;
                var isolatedElementList = $scope.elementList();
                var defaultLayoutOptions = {
                    scrollAfter: 10
                };
                $scope.layoutParams = _.extend({}, defaultLayoutOptions, $scope.layoutOptions());

                /**
                 * Should filter the array of elements either if a property is completely absent or if it is explicitly set to true
                 * @param {*} elementMapping: The mapping of element properties to expected properties
                 * @param {*} elementList: An array of elements
                 * @returns {*}
                 */
                var excludeFromList = function(elementMapping, elementList) {
                    return _.filter(elementList, function(element) {
                        return _.isUndefined(element[elementMapping.visible]) || element[elementMapping.visible];
                    });
                };

                /**
                 * Should return a string with the main title
                 * @param {*} elementKey: The id of an element
                 * @param {*} elementMapping: The mapping of element properties to expected properties
                 * @param {*} elementList: An array of elements
                 * @param {*} defaultText: A default text to display if no matching element id is found in the list of elements
                 * @returns {*|string}
                 */
                var initSelectedElement = function(elementKey, elementMapping, elementList, defaultText) {
                    var el = _.find(elementList, function(element) {
                        return element[elementMapping.key] === elementKey;
                    });
                    if (!el) {
                        var defaultElement = {};
                        defaultElement[elementMapping.title] = defaultText || '...';
                        defaultElement[elementMapping.description] = '';
                        return defaultElement;
                    }
                    return el;
                };
                // workaround for defaultElementKey arriving late by AJAX request in UM
                // when the defaultElementKey is not present at time of rendering,
                // it will not be processed when changed later
                // so set a simple watcher that destroys itself when value is changed
                if (!$scope.defaultElementKey || $scope.watchKey) {
                    keyWatch = $scope.$watch('defaultElementKey', function(val) {
                        if (val) {
                            $scope.selectedElement = initSelectedElement($scope.defaultElementKey,
                                $scope.elementMapping, $scope.filteredElements, $scope.defaultText);
                            if (!$scope.watchKey) {
                                keyWatch();
                            }
                        }
                    });
                }
                $scope.filteredElements = excludeFromList($scope.elementMapping, isolatedElementList);
                $scope.selectedElement = initSelectedElement($scope.defaultElementKey,
                    $scope.elementMapping, $scope.filteredElements, $scope.defaultText);
                $scope.setSelected = function(elementIndex, element, event) {
                    if (!_.isUndefined(element[$scope.elementMapping.active])
                        && !element[$scope.elementMapping.active]) {
                        event.stopPropagation();
                        return false;
                    }
                    if (_.isEqual($scope.selectedElement, element)) {
                        event.stopPropagation();
                        return false;
                    }
                    $scope.selectedElement = element;
                    if ($scope.clickHandlers && _.isFunction($scope.clickHandlers.leftClick)) {
                        $scope.clickHandlers.leftClick(elementIndex, element);
                        $scope.isOpen = !$scope.isOpen;
                    }

                    return true;
                };
                if ($scope.debug) {
                    $scope.debug.initSelectedElement = initSelectedElement;
                    $scope.debug.excludeFromList = excludeFromList;
                }
                $scope.$on('$destroy', function() {
                    if (_.isFunction(keyWatch)) {
                        keyWatch();
                    }
                });
            }
        };
    }
})(window.angular, window._);
